import {ShortcutItemListVo} from '../../common/shared/api/gateway/shortcut/ShortcutItemListVo.interface';
import {ShortcutItemList} from '../generated/types';
import {createShortcutItem} from './ShortcutItem';

export function createShortcutItemList({
  title,
  total_count,
  list,
}: ShortcutItemListVo): ShortcutItemList {
  return {
    title,
    totalCount: total_count,
    list: list.map(createShortcutItem),
  };
}
